import React, { PropsWithChildren } from 'react'
import { ActionModule } from '@typesApp/ActionModule'
import { CustomerContext } from '@typesApp/Customer'
import { HostEnvironment } from '@typesApp/Environment'
import { WidgetContextHolder } from '@typesApp/WidgetContextHolder'
import { WidgetContext } from '@context/widget-context/widgetContext'
import { useAppInit } from './hooks/useAppInit'

export type WidgetProps = PropsWithChildren & {
  widgetContext?: WidgetContextHolder
}

export type WidgetWithConfigurationProps = PropsWithChildren & {
  environment: HostEnvironment
  actionModule: ActionModule
  customerContext: CustomerContext
  widgetContext?: WidgetContextHolder
}

export const WidgetHOC: React.FC<WidgetProps> = props => {
  const { widgetContext } = props

  return <WidgetContext.Provider value={widgetContext ?? {}}>{props.children}</WidgetContext.Provider>
}

export const WidgetWithConfigurationHOC: React.FC<WidgetWithConfigurationProps> = props => {
  const { customerContext, environment, actionModule, widgetContext } = props
  useAppInit({ customerContext, environment, actionModule })

  return <WidgetContext.Provider value={widgetContext ?? {}}>{props.children}</WidgetContext.Provider>
}
